
import React from 'react';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import { FormattedMessage, injectIntl } from 'react-intl';

import {Mixpanel} from 'helpers/Mixpanel';

import './ScheduleSearchFilterComponent.scss';
import SelectDepartmentPopover from './SelectDepartmentPopover';
import SelectGroupPopover from './SelectGroupPopover';
import SelectSkillPopover from './SelectSkillPopover';

class ScheduleSearchFilterComponent extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isShowingFilterDropDown: false,
      isShowingFilterLogicBubble: false,
      searchTerm: '',
      selectedDepartment: null,
      selectedGroup: null,
      selectedSkill: null,

      isShowingDepartmentSelectPopover: false,
      isShowingGroupSelectPopover: false,
      isShowingSkillSelectPopover: false,

      dropdownPos: { top: 0, left: 0 },
    };
  }

  handleAddFilterClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    { !this.state.isShowingFilterDropDown && Mixpanel.track('Add Filters on Sched') };
    this.setState({
      isShowingFilterDropDown: !this.state.isShowingFilterDropDown,
      dropdownPos: {
        top: rect.bottom + window.scrollY + 4, // 4px spacing
        left: rect.left + window.scrollX,
      }
    });
  }

  handleDeleteFilterClick = () => {
    const { handleDepartmentSelect, handleGroupSelect, handleSkillSelect } = this.props;
    this.setState({
      selectedDepartment: null,
      selectedGroup: null,
      selectedSkill: null,
      isShowingFilterDropDown: false,
      isShowingFilterLogicBubble: false,
      isShowingDepartmentSelectPopover: false,
      isShowingGroupSelectPopover: false,
      isShowingSkillSelectPopover: false,
    });
    handleDepartmentSelect(null);
    handleGroupSelect(null);
    handleSkillSelect(null);

    Mixpanel.track('Delete Schedule Calendar Filter');
  }

  handleDeleteFilterClick = (filterType) => {
    const { handleDepartmentSelect, handleGroupSelect, handleSkillSelect } = this.props;

    this.setState((prev) => {
      const newState = { ...prev };
      switch (filterType) {
        case 'department':
          newState.selectedDepartment = null;
          handleDepartmentSelect(null);
          break;
        case 'group':
          newState.selectedGroup = null;
          handleGroupSelect(null);
          break;
        case 'skill':
          newState.selectedSkill = null;
          handleSkillSelect(null);
          break;
      }
      return newState;
    });
    Mixpanel.track('Delete Filter', { type: filterType });
  };



  dropDownItemSelected = (e) => {
    this.setState({
      isShowingFilterDropDown: false,
      isShowingFilterLogicBubble: true,
      isShowingDepartmentSelectPopover: e === 1,
      isShowingGroupSelectPopover: e === 2,
      isShowingSkillSelectPopover: e === 3,
    });
  }

  handleKeyPress = (event) => {
    const { notifySearchTermChanged, } = this.props;
    const { searchTerm, } = this.state;

    if (event.keyCode === 13) {
      notifySearchTermChanged(searchTerm);
      Mixpanel.track('Search on Sched', { 'keyword': searchTerm });
    }
  }

  handleSearchChanged = (event) => {
    const { notifySearchTermChanged, } = this.props;
    event.preventDefault();
    this.setState({ searchTerm: event.target.value });
    if (event.target.value === '') {
      notifySearchTermChanged('');
    }
  }

  handleDepartmentSelect = (e) => {
    const { handleDepartmentSelect } = this.props;
    this.setState({ selectedDepartment: e, isShowingDepartmentSelectPopover: false });
    handleDepartmentSelect(e);
  }

  handleGroupSelect = (e) => {
    const { handleGroupSelect } = this.props;
    this.setState({ selectedGroup: e, isShowingGroupSelectPopover: false });
    handleGroupSelect(e);
  }

  handleSkillSelect = (e) => {
    const { handleSkillSelect } = this.props;
    this.setState({ selectedSkill: e, isShowingSkillSelectPopover: false });
    handleSkillSelect(e);
  }

  render() {
    const { searchTerm, locationSettings, departments, channels, skills, intl } = this.props;
    const { isShowingFilterDropDown, dropdownPos, isShowingFilterLogicBubble, isShowingDepartmentSelectPopover, selectedDepartment, isShowingGroupSelectPopover, isShowingSkillSelectPopover, selectedGroup, selectedSkill } = this.state;

    const addFilterText = (<FormattedMessage id="SearchFilter.addFilter" defaultMessage="Add Filter" />);

    const departmentIsText = (<FormattedMessage id="SearchFilter.departmentIs" defaultMessage="Department is" />);
    const departmentText = (<FormattedMessage id="SearchFilter.department" defaultMessage="Department" />);

    const groupText = (<FormattedMessage id="SearchFilter.group" defaultMessage="Group" />);
    const groupIs = (<FormattedMessage id="SearchFilter.groupIs" defaultMessage="Group is" />);

    const skillText = (<FormattedMessage id="SearchFilter.skill" defaultMessage="Skill" />);
    const skillIs = (<FormattedMessage id="SearchFilter.skillIs" defaultMessage="Skill is" />);

    const placeholderText = { id: 'SearchFilter.placeholder', defaultMessage: 'Search' };

    // console.log("Deepak Channels departments - ", departments);
    // console.log("Deepak Channels Groups - ", channels);
    // console.log("Deepak Channels skills - ", skills);
    // console.log("Deepak locationSettings - ", locationSettings);

    const showFilterButton =
      (locationSettings?.cfg__departments === 1 && !selectedDepartment) ||
      !selectedGroup ||
      (locationSettings?.cfg__skill === 1 && !selectedSkill);

    return (
      <div className="search-filter-container">
        <div className='zero-col-container'>
          <input className="search-box"
            onChange={this.handleSearchChanged}
            onKeyUp={this.handleKeyPress}
            type="text"
            placeholder={intl.formatMessage(placeholderText)}
            value={searchTerm} />
        </div>

        <div className="first-col-container">
          {selectedDepartment && (
            <div
              className="filter-logic"
              onClick={() => this.handleDeleteFilterClick('department')}
            >
              <label className="filter-subject averta-semibold">
                {departmentIsText}
              </label>
              <label className="filter-object">{selectedDepartment.name}</label>
              <button className="del-filter-btn">
                <img src="/icons/close-icon.svg" alt="delete" />
              </button>
            </div>
          )}

          {selectedGroup && (
            <div
              className="filter-logic"
              onClick={() => this.handleDeleteFilterClick('group')}
            >
              <label className="filter-subject averta-semibold">{groupIs}</label>
              <label className="filter-object">{selectedGroup.channel_name}</label>
              <button className="del-filter-btn">
                <img src="/icons/close-icon.svg" alt="delete" />
              </button>
            </div>
          )}

          {selectedSkill && (
            <div
              className="filter-logic"
              onClick={() => this.handleDeleteFilterClick('skill')}
            >
              <label className="filter-subject averta-semibold">{skillIs}</label>
              <label className="filter-object">{selectedSkill.skill_content}</label>
              <button className="del-filter-btn">
                <img src="/icons/close-icon.svg" alt="delete" />
              </button>
            </div>
          )}

          {isShowingDepartmentSelectPopover && (
            <SelectDepartmentPopover
              handleDepartmentSelect={this.handleDepartmentSelect}
              departments={departments}
              dropdownPos={this.state.dropdownPos}
            />
          )}

          {isShowingGroupSelectPopover && (
            <SelectGroupPopover
              handleGroupSelect={this.handleGroupSelect}
              groups={channels}
              dropdownPos={this.state.dropdownPos}
            />
          )}

          {isShowingSkillSelectPopover && (
            <SelectSkillPopover
              handleSkillSelect={this.handleSkillSelect}
              skills={skills}
              dropdownPos={this.state.dropdownPos}
            />
          )}
        </div>

        <div className='second-col-container'>

          {showFilterButton && (
            <button className="add-filter-button averta-semibold" onClick={this.handleAddFilterClick}>
              {addFilterText}
            </button>
          )}

          {isShowingFilterDropDown && dropdownPos && (
            <div className="filter-dropdown"
              style={{
                position: 'absolute',
                top: dropdownPos.top,
                left: dropdownPos.left,
                zIndex: 3
              }}>
              <ul className="filter-list">
                {locationSettings?.cfg__departments === 1 && (
                  <li onClick={() => this.dropDownItemSelected(1)}>{departmentText}</li>
                )}
                <li onClick={() => this.dropDownItemSelected(2)}>{groupText}</li>
                {locationSettings?.cfg__skill === 1 && (
                  <li onClick={() => this.dropDownItemSelected(3)}>{skillText}</li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }
}


export default injectIntl(ScheduleSearchFilterComponent);
